var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.productOffer.name)?_c('span',[_vm._v(_vm._s(_vm.productOffer.name))]):(_vm.productOffer.codename)?_c('span',[_vm._v(_vm._s(_vm.productOffer.codename))]):_vm._e()}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7bf35ef7","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProductOfferItem.vue
// module id = 320
// module chunks = 1